import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";

export default function ViewClientDetails({ ipoData ,setIpoData}) {
  const { id } = useParams();
  const navigate = useNavigate();
  const { token } = useSelector((s) => s.login);
  const tempToken = localStorage.getItem("token") || token;

  const [ipoDetails, setIpoDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [investors, setInvestors] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchIpoDetails = async (pageNum = 1) => {
    setLoading(true);
    try {
      const base = `${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_API_TYPE}`;
      const res = await axios.get(`${base}/ipoManageClient/ipo/${ipoData?.id}?page=${pageNum}`, {
        headers: { Authorization: `Bearer ${tempToken}` },
      });

      const data = res?.data?.data || {};
      setIpoDetails(data);
      setInvestors(data.list || []);
      setTotalPages(data.totalPages || 1);
      setPage(data.currentPage || 1);
    } catch (err) {
      console.error("Error fetching IPO details:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (ipoData) fetchIpoDetails();
  }, [ipoData]);

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    return new Date(dateStr).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  console.log("ipoData",ipoData)

  return (
    <div className="w-full flex justify-center bg-gray-50 min-h-screen py-10">
      <div className="w-[95%] max-w-6xl bg-white rounded-xl shadow p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <button
            onClick={() => setIpoData()}
            className="text-[#065697] text-sm hover:underline"
          >
            ← Back
          </button>
          <h2 className="text-xl font-semibold text-[#065697]">
             {ipoData?.name}
          </h2>
          <div></div>
        </div>

        {/* IPO Info */}
        {ipoDetails && (
          <div className="mb-6 bg-[#E6EEF4] rounded-xl p-4 border border-[#CDDDEA]">
            <p>
              <span className="font-medium text-[#065697]">Start Date:</span>{" "}
              {formatDate(ipoData?.startDate)}
            </p>
            <p>
              <span className="font-medium text-[#065697]">End Date:</span>{" "}
              {formatDate(ipoData?.endDate)}
            </p>
          </div>
        )}

        {/* Investors Table */}
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-200 rounded-lg text-sm">
            <thead className="bg-[#F8FAFC]">
              <tr className="text-[#065697] font-semibold text-left">
                <th className="border-b p-3 w-16">Sr. No.</th>
                <th className="border-b p-3">Investor Name</th>
                <th className="border-b p-3 text-right">Proposed Amount (₹)</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="3" className="text-center py-4">
                    Loading...
                  </td>
                </tr>
              ) : investors.length > 0 ? (
                investors.map((inv, idx) => (
                  <tr key={inv.id} className="hover:bg-gray-50">
                    <td className="p-3 border-b">{idx + 1}</td>
                    <td className="p-3 border-b">
                      {inv.user?.name || "Unknown"}
                    </td>
                    <td className="p-3 border-b text-right">
                      ₹{Number(inv.proposedAmount || 0).toLocaleString()}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center py-4 text-gray-500">
                    No investor data found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="flex justify-center items-center gap-2 mt-6">
            <button
              onClick={() => fetchIpoDetails(page - 1)}
              disabled={page === 1}
              className={`px-3 py-1 border rounded ${
                page === 1
                  ? "text-gray-400 border-gray-200"
                  : "text-[#065697] border-[#065697]"
              }`}
            >
              Prev
            </button>
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                onClick={() => fetchIpoDetails(i + 1)}
                className={`px-3 py-1 border rounded ${
                  page === i + 1
                    ? "bg-[#065697] text-white"
                    : "text-[#065697] border-[#065697]"
                }`}
              >
                {i + 1}
              </button>
            ))}
            <button
              onClick={() => fetchIpoDetails(page + 1)}
              disabled={page === totalPages}
              className={`px-3 py-1 border rounded ${
                page === totalPages
                  ? "text-gray-400 border-gray-200"
                  : "text-[#065697] border-[#065697]"
              }`}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
